import { LicenseInfo } from '@mui/x-license-pro';

export const registerMuiLicense = () => {
  LicenseInfo.setLicenseKey(
    '89bca584c7169aa182b3894e40e90ea7Tz0xMjExOTcsRT0xNzkzNDkxMTk5MDAwLFM9cHJvLExNPXN1YnNjcmlwdGlvbixQVj1RMy0yMDI0LEtWPTI='
  );
};
